module.exports = __webpack_public_path__ + "img/photo_220250565_1.975b6bd3.png";